import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { CopyIcon } from "@icons";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { SendingEmailRow } from "../sendingEmailsViewConfig";

export const SendingEmailCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingEmailRow, string>) => (
        <ViewTableCell>
            <CopyOnClick value={row.original.email} className="cursor-pointer">
                {row.original.email} <CopyIcon className="ml-1" />
            </CopyOnClick>
        </ViewTableCell>
    ),
);
